import logo from './logo.svg';
import './App.css';
import AppRoutes from './Routes/appRoutes';
import Modal from 'react-modal';
import { useLanguage } from './contexts/LanguageContext';

// Set the app element for react-modal
Modal.setAppElement('#root');

function App() {
  const { currentLanguage } = useLanguage();
  
  return (
    <div key={currentLanguage}>
      <AppRoutes/>
    </div>
  );
}

export default App;
